import type { Ref } from 'vue'

export default function useSubNav(type: SubNavType | Ref<SubNavType | null>) {
  const { t } = useI18n()

  const { id: businessId, isCelloEnabled } = storeToRefs(useBusinessStore())
  const { track } = useAnalytics()

  const navigationItems = computed<(NavigationItem | NavigationDivider)[]>(() => {
    const navType = unref(type)

    switch (navType) {
      case 'profile':
        return [
          {
            identifier: 'profile',
            route: '/profile',
            title: t('global.navigation.personal_data'),
            icon: 'custom:circle_profile',
          },
          {
            identifier: 'signature_standards',
            route: '/profile/signature-standards',
            title: t('global.navigation.signature_standards'),
            icon: 'custom:signature_standards',
          },
          {
            identifier: 'visual_signatures',
            route: '/profile/visual-signature',
            title: t('global.navigation.visual_signature'),
            icon: 'custom:artboard',
          },
          // Careful, the identifier here will be used as the element ID by which Cello will find the element
          // to attach the widget logic to. (This is apparently configured in the Cello account UI.)
          {
            identifier: 'referral',
            route: '',
            title: t('global.navigation.refer_a_friend'),
            icon: 'custom:referral',
            isDisabled: Boolean(businessId.value && !isCelloEnabled.value),
            onSelect: () => track(ANALYTICS_EVENTS.REFERRAL_WIDGET_OPENED),
          },
          {
            identifier: 'settings',
            route: '/profile/settings',
            title: t('global.navigation.settings'),
            icon: 'custom:gear',
          },
          { divider: true },
          { identifier: 'logout', route: '/logout', title: t('global.navigation.logout'), icon: 'custom:leave' },
        ]
      case 'business-profile':
        return [
          {
            identifier: 'profile',
            route: '/business/profile',
            title: t('business.navigation.business_profile'),
            icon: 'custom:business_profile',
          },
          {
            identifier: 'aes4biz',
            route: '/business/profile/aes-for-business',
            title: t('business.profile.navigation.aes'),
            icon: 'custom:business_aes',
          },
          { identifier: 'logout', route: '/logout', title: t('global.navigation.logout'), icon: 'custom:leave' },
        ]
      default:
        return []
    }
  })

  return {
    navigationItems,
  }
}
